module.exports = __webpack_public_path__ + "img/579241_B5D25D_0E1D2D_97C284-256px.148c3711.png";